export default __webpack_public_path__ + "static/media/history.74b35810.svg";